import { create } from 'zustand';
import { db } from '../lib/firebase';
import { collection, addDoc, getDocs, query, orderBy, doc, updateDoc } from 'firebase/firestore';

const useExpertStore = create((set, get) => ({
    experts: [],
    loading: false,
    error: null,

    fetchExperts: async () => {
        set({ loading: true });
        try {
            const q = query(collection(db, 'experts'), orderBy('createdAt', 'desc'));
            const querySnapshot = await getDocs(q);
            const experts = querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            set({ experts, loading: false, error: null });
        } catch (error) {
            console.error("Error fetching experts:", error);
            set({ error: error.message, loading: false });
        }
    },

    createExpert: async (expertData) => {
        set({ loading: true });
        try {
            const newExpert = {
                ...expertData,
                createdAt: new Date().toISOString(),
                // Default values to ensure consistency
                tools: expertData.tools || [],
            };

            const docRef = await addDoc(collection(db, 'experts'), newExpert);

            // Optimistic update or re-fetch
            const currentExperts = get().experts;
            set({
                experts: [{ id: docRef.id, ...newExpert }, ...currentExperts],
                loading: false,
                error: null
            });

            return docRef.id;
        } catch (error) {
            console.error("Error creating expert:", error);
            set({ error: error.message, loading: false });
            throw error;
        }
    },

    updateExpert: async (id, updates) => {
        set({ loading: true });
        try {
            // 1. Update Firestore
            const docRef = doc(db, 'experts', id);
            await updateDoc(docRef, {
                ...updates,
                updatedAt: new Date().toISOString()
            });

            // 2. Update Local State
            const currentExperts = get().experts;
            const updatedExperts = currentExperts.map(ex =>
                ex.id === id ? { ...ex, ...updates } : ex
            );
            set({ experts: updatedExperts, loading: false, error: null });

        } catch (error) {
            console.error("Error updating expert:", error);
            set({ error: error.message, loading: false });
            throw error;
        }
    }
}));

export default useExpertStore;
